<span class="ds-whitespace-pre-line"><ng-content></ng-content></span>
<div
  *ngIf="isFirst && icon && alignment === 'left'"
  class="ds-absolute ds-top-2xs ds-rounded-full ds-p-2xs -ds-left-[50px]"
  [class.ds-bg-primary-yellow]="icon === 'agent'"
>
  <span *ngIf="icon === 'agent'" class="ds-icons-call-center"></span>
  <span *ngIf="icon === 'bot'" class="ds-icons-chat"></span>
  <span *ngIf="icon === 'warning'" class="ds-icons-information"></span>
</div>
